export default __webpack_public_path__ + "static/media/368.33eea365.png";